import { Typography } from '@/components/ui/typography';
import { cn } from '@/lib/utils';
import { formatPriceDisplay } from '@/util/formatting';
import { isFreeTier, type FloorPlanTier } from './floorPlanOffer';

/**
 * A tier's price. Basic reads "Free", never "Included" — the story requires
 * the free plan to read as free — and no paid tier ever reads as free. A tier
 * that cannot be ordered yet shows no price: it is Coming Soon, not on sale.
 */
export function FloorPlanPrice({
  tier,
  className
}: {
  tier: FloorPlanTier;
  className?: string;
}) {
  if (!tier.orderable) return null;

  const isFree = isFreeTier(tier);
  return (
    <Typography
      variant="body-semibold"
      className={cn(
        isFree ? 'uppercase tracking-wide text-success' : 'text-foreground',
        className
      )}
    >
      {isFree ? 'Free' : `$${formatPriceDisplay(tier.price)}`}
    </Typography>
  );
}
